import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { map, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { webConfig } from './webconfig';

@Injectable()
export class AppService {
    constructor(private http: Http, private _router: Router, private config: webConfig) { }

    //  public url = 'http://10.40.1.233:8001/';
    public url = this.config.url;
    //  public url = 'http://34.235.163.113:8001/';
    //public url = 'http://180.178.132.147:8001/';

    //    intereset rate = 20 -40
    // documet charge = 5 digit num
    // isurrance amount = positive num 
    // isurrance rate  = positive num 

    public get(_apiUrl): Observable<any> {
        return this.http.get(`${this.url}` + _apiUrl, this._header())
            .map(this.extractData)
            .catch(this.handleError);
    }

    public post(_apiUrl, item: any): Observable<any> {
        return this.http.post(`${this.url}` + _apiUrl, item, this._header())
            .map(this.extractData)
            .catch(this.handleError);
    }

    public put(_apiUrl, itemId: number, item: any): Observable<any> {
        return this.http.put(`${this.url}` + _apiUrl + itemId, item, this._header())
            .map(this.extractData)
            .catch(this.handleError);
    }

    public delete(_apiUrl, item: any): Observable<any> {
        return this.http.delete(`${this.url}` + _apiUrl + item, this._header())
            .map(this.extractData
            )
            .catch(this.handleError);
    }


    _header() {
        let user = localStorage.getItem('currentUser');
        if (!!user) {
            let temp = JSON.parse(user)
            let token = temp['token'];
            const headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': 'jwt ' + token });
            const options = new RequestOptions({ headers: headers });
            return options;
        }
    }


    public extractData(res: Response) {
        let body = res.json();
        return body;
    }
    public handleError(error: Response | any) {
        return Observable.throw(error.status);
    }


}





// WEBPACK FOOTER //
// D:/Finca/Finca UI/UI/src/app/app.service.ts